import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions } from '@angular/router';
import { MainLayoutComponent } from '@layouts/containers/main-layout/main-layout.component';
// import { AuthLayoutComponent } from '@layouts/containers/auth-layout/auth-layout.component';
import { SidebarLayoutComponent } from '@layouts/containers/sidebar-layout/sidebar-layout.component';
import { AuthGuard } from '@core/guard/auth/auth.guard';
import { CourseAccessGuard } from '@core/guard/expired-course/course-access.guard';
import { ConferenceAccessGuard } from '@core/guard/expired-conference/conference-access.guard';
import { titleResolver } from '../title.resolver';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { PushLiveSidebarLayoutComponent } from '@layouts/containers/push-live-sidebar-layout/push-live-sidebar-layout.component';
import { ActivityReturnComponent } from './shared/components/activity-return/activity-return.component';
import { PushLiveEntryComponent } from '@modules/push-live/push-live-entry/push-live-entry.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
    title: titleResolver,
  },
  {
    path: 'auth',
    // component: AuthLayoutComponent,
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
    title: titleResolver,
  },
  {
    path: 'activity',
    component: MainLayoutComponent,
    children: [
      {
        path: ':activityType/:activityUuid/return',
        component: ActivityReturnComponent,
      },
    ],
    title: titleResolver,
  },
  {
    path: 'courses',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/course/course.module').then((m) => m.CourseModule),
    title: titleResolver,
  },
  {
    path: 'live',
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./modules/conference/conference.module').then((m) => m.ConferenceModule),
    title: titleResolver,
  },

  {
    path: 'push-live',
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./modules/push-live/push-live.module').then((m) => m.PushLiveModule),
  },

  {
    path: 'push',
    component: PushLiveSidebarLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/push-live-chapter/push-live-chapter.module').then(
        (m) => m.PushLiveChapterModule
      ),
    title: titleResolver,
  },

  {
    path: 'series',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/series/series.module').then((m) => m.SeriesModule),
    title: titleResolver,
  },
  {
    path: 'credit',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [ConferenceAccessGuard],
    loadChildren: () => import('./modules/credit/credit.module').then((m) => m.CreditModule),
    title: titleResolver,
  },
  {
    path: 'chapter',
    component: SidebarLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [CourseAccessGuard],
    loadChildren: () => import('./modules/chapter/chapter.module').then((m) => m.ChapterModule),
    title: titleResolver,
  },
  {
    path: 'my-account',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/my-account/my-account.module').then((m) => m.MyAccountModule),
    title: titleResolver,
  },

  {
    path: 'c/push/:pushLiveUuid/:userUuid',
    component: PushLiveEntryComponent,
  },

  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '404' },
];

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled',
  scrollOffset: [0, 100],
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
